import React from "react";
import {
    FormLayout,
    HeaderActions,
    Heading,
    Input,
    Panel,
    Switch,
    Text,
} from "@/ui";
import { Icon } from "@/components";
import useMeta from "../../base/hooks/useMeta";
import useForm from "../../base/hooks/form/useForm";
import useValidator from "../../base/hooks/form/useValidator";
import useFormActions from "../../base/hooks/form/useFormActions";
import {
    MUTATION_UPADTE_AUTHORIZE_NET_APP,
    QUERY_LIST_STORE_APPS,
} from "../../apollo/module-operations/app";
import _ from "lodash";
import styles from "./GeneralsForm.module.scss";

const SaveIcon = () => <Icon icon="save" />;

const fieldError = (validator, name) =>
    validator?.[name]?.isInvalid ? validator[name].message : undefined;

const AppAuthorizeNetForm = ({ toolbar, app }) => {
    const { user } = useMeta();

    const { inputs, setInputs, inputChange } = useForm();

    if (!_.get(inputs, "id", null)) {
        setInputs(app);
    }

    const { validator, isValid, isSubmited } = useValidator(
        [
            {
                field: "api_login_id",
                method: "isEmpty",
                validWhen: false,
                message: "This API Login Id is required.",
            },
            {
                field: "transaction_key",
                method: "isEmpty",
                validWhen: false,
                message: "This Transaction Key is required.",
            },
            {
                field: "test_api_login_id",
                method: "isEmpty",
                validWhen: false,
                message: "This API Login Id is required.",
            },
            {
                field: "test_transaction_key",
                method: "isEmpty",
                validWhen: false,
                message: "This Transaction Key is required.",
            },
        ],
        {
            ...inputs,
        },
    );

    let options = {
        variables: {
            account_id: user.accountId,
            store_id: user.storeId,
            input: {
                ...inputs,
                type: "AuthorizeNet",
                sandbox: inputs.sandbox === "true" || inputs.sandbox === true,
            },
        },
    };

    const { createOrUpdate, loading } = useFormActions(
        "id",
        "Authorize Net",
        "",
        MUTATION_UPADTE_AUTHORIZE_NET_APP,
        [
            {
                query: QUERY_LIST_STORE_APPS,
                variables: {
                    account_id: user.accountId,
                    store_id: user.storeId,
                },
                skip: user.loading || !user.accountId || !user.storeId,
            },
        ],
        options,
        "",
        isValid,
        isSubmited,
        "primary",
    );

    const isSandbox = Boolean(inputs.sandbox);
    const apiLoginIdField = isSandbox ? "test_api_login_id" : "api_login_id";
    const transactionKeyField = isSandbox
        ? "test_transaction_key"
        : "transaction_key";

    return (
        <Panel
            className={styles.root}
            header={
                <div className={styles.headerBar}>
                    <div className={styles.headerText}>
                        <Heading level={4}>Authorize Net</Heading>
                        <Text tone="secondary" variant="body-sm">
                            Authorize Net Information
                        </Text>
                    </div>
                    <div className={styles.headerActions}>
                        {toolbar ? toolbar : null}
                        <HeaderActions
                            actions={[
                                {
                                    id: "update",
                                    label: "Update",
                                    icon: loading ? undefined : <SaveIcon />,
                                    loading,
                                    disabled: loading,
                                    onClick: () => createOrUpdate(),
                                },
                            ]}
                            aria-label="Authorize Net actions"
                        />
                    </div>
                </div>
            }
            showHeaderDivider
        >
            <FormLayout>
                <FormLayout.Section title="Information">
                    <Switch
                        checked={isSandbox}
                        label="Sandbox"
                        name="sandbox"
                        onChange={inputChange}
                    />
                    <FormLayout.Grid columns={2} maxWidth="twoThirds">
                        <Input
                            error={fieldError(validator, apiLoginIdField)}
                            fullWidth
                            label="Api login id"
                            name={apiLoginIdField}
                            onChange={inputChange}
                            value={inputs[apiLoginIdField] || ""}
                        />
                        <Input
                            error={fieldError(validator, transactionKeyField)}
                            fullWidth
                            label="Transaction key"
                            name={transactionKeyField}
                            onChange={inputChange}
                            value={inputs[transactionKeyField] || ""}
                        />
                    </FormLayout.Grid>
                </FormLayout.Section>
            </FormLayout>
        </Panel>
    );
};

export default AppAuthorizeNetForm;
